import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Switch,
  FormControlLabel,
  Box,
} from '@mui/material';
import Capa from '../../Controls/Capa/Capa';

const EditReportServer = ({ open, onClose, onSave, initialData }) => {
  const [formData, setFormData] = useState({
    reporte: '',
    ruta: '',
    activo: false,
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        id: initialData.id,
        reporte: initialData.Reporte || '',
        ruta: initialData.Group || '',
        activo: initialData.Activo === -1,
      });
    }
  }, [initialData]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = () => {
    onSave({
      id: formData.id,
      Reporte: formData.reporte,
      Group: formData.ruta,
      Activo: formData.activo ? -1 : 0,
    });
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          p: 2,
        }}
      >
        <Capa title="Editar registro" onAceptar={handleSave} onCancel={onClose}>
          <DialogContent>
            <TextField
              label="Reporte"
              value={formData.reporte}
              onChange={(e) => handleChange('reporte', e.target.value)}
              fullWidth
              margin="dense"
            />
            <TextField
              label="Ruta"
              value={formData.ruta}
              onChange={(e) => handleChange('ruta', e.target.value)}
              fullWidth
              margin="dense"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={formData.activo}
                  onChange={(e) => handleChange('activo', e.target.checked)}
                />
              }
              label={formData.activo ? 'Activo' : 'Inactivo'}
            />
          </DialogContent>
        </Capa>
      </Box>
    </Dialog>
  );
};

export default EditReportServer;
